module.exports = __webpack_public_path__ + "img/09_3_1_2.3e12d731.png";